import request, { type ApiResponse, type RequestConfig } from '@/utils/request'

export const getClcDoor = (clcDoorCode: string, taskId: string, config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.get(`/app/activiti/getClcDoor/${clcDoorCode}/${taskId}`, undefined, config)
}

export const getDoorObserverClcDoor = (clcDoorCode: string, config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.get(`/app/door/observer/getClcDoor/${clcDoorCode}`, undefined, config)
}

export const updateClcDoor = (data: any, config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.post(`/app/activiti/updateClcDoor`, data, config)
}

export const getConfigList = (
  type: string,
  code?: string,
  start = 1,
  length = 500,
  config?: RequestConfig,
): Promise<ApiResponse<any>> => {
  const payload: any = { type, start, length }
  if (code) payload.code = code
  return request.post(`/app/activiti/configList`, payload, config)
}

export const getClcDoorMasterKiwiUrl = (
  clcDoorCode: string,
  config?: RequestConfig,
): Promise<ApiResponse<string>> => {
  return request.post(`/app/activiti/getClcDoorMasterKiwiUrl`, { clcDoorCode }, config)
}

export const getConceptList = (
  start = 1,
  length = 500,
  config?: RequestConfig,
): Promise<ApiResponse<any>> => {
  return request.post(`/app/baseDataMange/conceptList`, { start, length }, config)
}

export const getAccountList = (
  start = 1,
  length = 1000,
  config?: RequestConfig,
): Promise<ApiResponse<any>> => {
  return request.post(`/app/baseDataMange/accountList`, { start, length }, config)
}
